import { render, staticRenderFns } from "./org-list.vue?vue&type=template&id=4aee84d4&scoped=true"
import script from "./org-list.vue?vue&type=script&lang=ts"
export * from "./org-list.vue?vue&type=script&lang=ts"
import style0 from "./org-list.vue?vue&type=style&index=0&id=4aee84d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aee84d4",
  null
  
)

export default component.exports